import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('internationalizedArrayTextValue', {
    value: {
        title: 'Value',
        type: 'text'
    }
});
var validator = z.object({
    value: z.string()
}).partial();
schema.internationalizedArrayTextValue;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayTextValue.js.map